import Dialog from "@/components/Dialog";
import { t } from "@/utils";
import { contentEnum } from "./contentEnum";
import { useMonitoringDialog } from "./useMonitoringDialog";

export default function MonitoringWarningDialog() {
  const { isOpen, close, key, resolver } = useMonitoringDialog();
  if (!key) return null;
  const { title, body, Icon, iconFill, buttonKeys } = contentEnum[key];
  return (
    <Dialog
      isOpen={isOpen}
      onClose={resolver ? () => resolver(false) : close}
      onConfirm={resolver ? () => resolver(true) : close}
      title={t(title)}
      body={t(body)}
      buttons={{
        cancel: { label: t(buttonKeys.cancel || "buttons.cancel") },
        confirm: { label: t(buttonKeys.confirm || "buttons.ok") }
      }}
      iconProps={{ fill: iconFill, size: "2rem" }}
      icon={Icon}
    />
  );
}
